import { render, staticRenderFns } from "./pocket_service.vue?vue&type=template&id=ca4851a6&"
import script from "./pocket_service.vue?vue&type=script&lang=js&"
export * from "./pocket_service.vue?vue&type=script&lang=js&"
import style0 from "./pocket_service.vue?vue&type=style&index=0&id=ca4851a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports